/**
 * 使用 Fetch API 发送跨域请求的通用函数
 * @param {string} url - 请求的URL
 * @param {string} method - HTTP方法 (GET, POST, PUT, DELETE等)
 * @param {object} data - 请求体数据 (POST/PUT时使用)
 * @param {object} headers - 自定义请求头
 * @param {boolean} withCredentials - 是否发送凭证(cookies等)
 * @returns {Promise} 返回Promise对象
 */
async function crossDomainRequest(url, method = 'GET', data = null, headers = {}, withCredentials = false) {
    try {
        // 配置请求选项
        const options = {
            method: method.toUpperCase(),
            headers: {
                'Content-Type': 'application/json',
                ...headers // 合并自定义头部
            },
            credentials: withCredentials ? 'include' : 'same-origin',
            mode: 'cors' // 明确指定跨域模式
        };
        
        // 如果是POST、PUT等请求且有数据，添加请求体
        if (data && ['POST', 'PUT', 'PATCH'].includes(options.method)) {
            options.body = JSON.stringify(data);
        }
        
        // 发送请求
        const response = await fetch(url, options);
        
        // 检查响应状态
        if (!response.ok) {
            throw new Error(`HTTP错误! 状态码: ${response.status}`);
        }
        
        // 根据响应内容类型解析数据
        const contentType = response.headers.get('content-type');
        let result;
        
        if (contentType && contentType.includes('application/json')) {
            result = await response.json();
        } else {
            result = await response.text();
        }
        
        return {
            success: true,
            data: result,
            status: response.status,
            headers: response.headers
        };
        
    } catch (error) {
        console.error('跨域请求失败:', error);
        return {
            success: false,
            error: error.message,
            data: null
        };
    }
}